module.exports = __webpack_public_path__ + "img/icon_team.e4e0583c.png";